import createLocalesContext from 'app/helpers/createLocalesContext';

const { LocalesContext, useLocales } = createLocalesContext();

export { LocalesContext, useLocales };
